import { Zap, ZapOff } from 'lucide-react'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const onlineKey = `online-status`
  const offlineKey = `offline-status`
  useEffect(() => {
    function onlineHandler() {
      closeSnackbar(offlineKey)
      setIsOnline(true)
      enqueueSnackbar(`Your're back online and connected to the internet`, {
        key: onlineKey,
        variant: 'success',
        autoHideDuration: 4000,
        iconVariant: {
          success: <Zap size={17} />,
        },
      })
    }

    function offlineHandler() {
      closeSnackbar(onlineKey)
      setIsOnline(false)
      enqueueSnackbar('Your internet connection is currently unavailable', {
        key: offlineKey,
        variant: 'error',
        persist: true,
        iconVariant: {
          error: <ZapOff size={17} />,
        },
      })
    }

    window.addEventListener('online', onlineHandler)
    window.addEventListener('offline', offlineHandler)

    return () => {
      window.removeEventListener('online', onlineHandler)
      window.removeEventListener('offline', offlineHandler)
    }
  }, [])

  return {
    isOnline,
  }
}
